import { Divider, Space, Text } from '@procurify/ui'

import { Price } from '@webapp/core/components/Price'
import { type CurrencyName } from '@webapp/core/entities/external/Currency/CurrencyName'
import { ConversationOrderSummaryValueStyled } from './styles/ConversationOrderSummaryValueStyled'
import { type ConversationCartCharge } from '../../value-objects/ConversationTurnItem'

export interface IConversationOrderSummaryTotalsProps {
  charges?: ConversationCartCharge[]
  total: Nullable<number>
  currency: CurrencyName
  totalLabel: string
}

export const ConversationOrderSummaryTotals = ({
  charges = [],
  total,
  currency,
  totalLabel,
}: IConversationOrderSummaryTotalsProps) => {
  const renderTotal = () => {
    if (total === null) return null
    return (
      <Space direction='horizontal' justify='space-between' align='center'>
        <Text inline bold>
          {totalLabel}
        </Text>
        <ConversationOrderSummaryValueStyled $isBold className='fs-mask'>
          <Price inline price={total} currency={currency} />
        </ConversationOrderSummaryValueStyled>
      </Space>
    )
  }

  return (
    <Space direction='vertical' size='xsmall'>
      {charges.map((charge, index) => (
        <Space
          key={`${index}_${charge.label}`}
          direction='horizontal'
          justify='space-between'
          align='center'
        >
          <Text inline color='textSecondary'>
            {charge.label}
          </Text>
          <ConversationOrderSummaryValueStyled $isSecondary className='fs-mask'>
            <Price
              inline
              fontWeight='normal'
              price={charge.amount.price}
              currency={charge.amount.currency}
            />
          </ConversationOrderSummaryValueStyled>
        </Space>
      ))}
      {charges.length > 0 && total !== null && <Divider space={0} />}
      {renderTotal()}
    </Space>
  )
}
